import React from "react";

export function GridGrow(){
    return (<div style={{ flex: "1 1 auto" }} />);
}